const StrateComparaisonFormule = {
    init() {
        // V1 => chaque select est modifiable individuellement
        /*
        $('.js_select_formules').change(function(){
            let this_domaine = $(this).parents('.domaine');
            this_domaine.find('.col_formule').removeClass('active');
            this_domaine.find( '.'+$(this).val() ).addClass('active');
        });        
        */

        // V2 => Tous les select se modifient en même temps
        $('.js_select_formules').change(
            function () {
                $('.js_select_formules').val($(this).val());
                $('.col_formule').removeClass('active');
                $('.' + $(this).val()).addClass('active');

                console.log($(this).find(':selected').data());
                if ($(this).find(':selected').data('ai')) {
                    $('.wrapper_select .ai-enabled').show()
                } else {
                    $('.wrapper_select .ai-enabled').hide()
                }
            }
        );
    },
};

export default StrateComparaisonFormule;
